/**
 * CartRemoveButton
 * @description Remove item from the cart.
 */
class CartRemoveButton extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);
